import axios from 'axios';
import store from '../store';
import { createConfirmation } from 'react-confirm';
import Confirmation from './Confirmation';
import { showAlertWithMessage,hideAlert,openChatGroup,onMessageReceive,onCvstChange,refreshMessageList,refreshNotiList,refreshChatSideBar } from '../actions/common-actions';
export function getAPIURL() {
  return "/code/apis.php";
}

const confirms = createConfirmation(Confirmation);
const imgPopupStyle = {
	overlay : {
    position          : 'fixed',
    top               : 0,
    left              : 0,
    right             : 0,
    bottom            : 0,
    backgroundColor   : 'rgba(0, 0, 0, 0.3)',
    zIndex 				  : '999',
    overflow: 'auto',
    display				:'flex',
    justifyContent: 'center',
    alignItems: 'center'
 },
  content : {
  	    position: 'relative',
  	top             : '0',
    left            : '0',
    right           : '0',
    bottom          : '0',
    margin			:'0',
    padding			:'10px',
    width			: '80%',
    height			: '80%',
    minWidth		:'300px',
    minHeight		:'200px',
    zIndex 				  : '999'
  }
};
const nmPopupStyle = {
	overlay : {
    position          : 'fixed',
    top               : 0,
    left              : 0,
    right             : 0,
    bottom            : 0,
    backgroundColor   : 'rgba(0, 0, 0, 0.3)',
    zIndex 				  : '999',
    overflow: 'auto',
    display				:'flex',
    justifyContent: 'center',
    alignItems: 'center'
 },
  content : {
  	    position: 'relative',
  	top             : '0',
    left            : '0',
    right           : '0',
    bottom          : '0',
    margin			:'0',
    padding			:'0px',
    width			: '485px',
    height			: 'auto',
    minWidth		:'300px',
    minHeight		:'200px',
    zIndex 				  : '999'
  }
};
const file_limit = 25*1024*1024;
export function ImagePopupStyle()
{
	return imgPopupStyle;
}
export function NMPopupStyle()
{
	return nmPopupStyle;
}
export function fileLimit()
{
	return file_limit;
}
export function confirm(confirmation, options = {}) {
  return confirms({ confirmation, ...options });
}
export function showAlert(message) {
  return store.dispatch(showAlertWithMessage({common: {msg:message,show:true}}));
}

export function dismissAlert() {
  return store.dispatch(hideAlert({common: {msg:'',show:false}}));
}
export function refreshMsg(value) {
  return store.dispatch(refreshMessageList({value:value}));
}
export function refreshNoti(value) {
  return store.dispatch(refreshNotiList({value:value}));
}
export function refreshSB(value) {
  return store.dispatch(refreshChatSideBar({value:value}));
}

export function openChatBox(group) {
  return store.dispatch(openChatGroup(group));
}
export function receiveMessage(data) {
  return store.dispatch(onMessageReceive(data));
}
export function cvstChange(data) {
  return store.dispatch(onCvstChange(data));
}

export function logout() {
  return axios.get('/code/apis.php?api=logout')
    .then(response => {	
    	if(response.data.status == 1)
    	{
    		return 1;
    	}
    	//console.log(response.data);
      
      return 0;
    });
}
export function getStatus(status) {
  if(status==1)
  {
  	return "online";
  }
  if(status==2)
  {
  	return "campus";
  }
  if(status==3)
  {
  	return "busy";
  }
  if(status==4)
  {
  	return "away";
  }
  return "offline";
}
export function getSectionDay(days) {
  var dayArr = days.split(";");
  var rel = "";
  if(dayArr[0]==1)
  {
  	rel+="M";
  }
  if(dayArr[1]==1)
  {
  	rel+="TU";
  }
  if(dayArr[2]==1)
  {
  	rel+="W";
  }
  if(dayArr[3]==1)
  {
  	rel+="TH";
  }
  if(dayArr[4]==1)
  {
  	rel+="F";
  }
  if(dayArr[5]==1)
  {
  	rel+="S";
  }

  return rel;
}


/** WEBPACK FOOTER **
 ** ./src/client/app/api/common-api.js
 **/